module.exports = __webpack_public_path__ + "img/checkbox-selected.8bdc5382.svg";